import { useRoom } from '@hook'
import { yupResolver } from '@hookform/resolvers/yup'
import { roomSchema } from '@schema'
import { useAppSelector } from '@store/hooks'
import { AddRoomFormMock, RoomResMock } from '@type/room.type'
import { FormButton, FormInputField, Modal, SelectInputField } from '@ui'
import { getError, showToast } from '@util'
import { Box, Form } from 'grommet'
import { FormProvider, useForm } from 'react-hook-form'

type Props = {
  defaultData?: RoomResMock
  onClose: () => void
}
export const EditRoom = ({ onClose, defaultData }: Props) => {
  const roomTypes = useAppSelector(state => state.config.room_types)
  const methods = useForm<AddRoomFormMock>({
    defaultValues: {
      price: String(defaultData?.attributes?.price) || '',
      room_number: defaultData?.attributes?.room_number || '',
      room_type: defaultData?.attributes?.room_type
    },
    resolver: yupResolver(roomSchema)
  })
  const {
    handleSubmit,
    formState: { isSubmitting }
  } = methods
  const { updateRoom } = useRoom({})

  const onSubmit = async (formData: AddRoomFormMock) => {
    const formRecObj = {
      data: {
        attributes: {
          ...formData
        },
        type: 'room'
      }
    }
    try {
      await updateRoom({ data: formRecObj, id: defaultData?.id as string })
      showToast(`room updated successfully`)
      onClose()
    } catch (error) {
      getError(error)
    }
  }
  return (
    <FormProvider {...methods}>
      <Modal onClose={onClose} title="Add Room">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Box overflow="auto" pad={{ horizontal: '32px', vertical: '16px' }} width={'530px'}>
            <Box className="mx-auto w-full max-w-[399px]" flex={false} gap={'20px'}>
              <Box
                flex={false}
                gap={'20px'}
                overflow="auto"
                pad={{ horizontal: '32px', vertical: '16px' }}
                style={{ minWidth: 'min(440px, calc(100vw - 1.5rem))' }}
              >
                <Box pad="0">
                  <FormInputField label="Number" name="room_number" placeholder="" />
                </Box>
                <Box pad="0">
                  <SelectInputField
                    dropProps={{
                      align: { left: 'left', right: 'right', top: 'bottom' }
                    }}
                    label="Type"
                    labelKey={'name'}
                    name="room_type"
                    options={roomTypes}
                    placeholder="Select Type"
                    valueKey={{ key: 'value', reduce: true }}
                  />
                </Box>
                <Box pad="0">
                  <FormInputField label="Amount" name="price" placeholder="" type="number" />
                </Box>
              </Box>
            </Box>
          </Box>
          <FormButton isLoading={isSubmitting} onClose={onClose} submit="Update" />
        </Form>
      </Modal>
    </FormProvider>
  )
}
